import { useRecoilState } from "recoil";
import { confirmPopupState } from "../../../../recoil/popup/confirmPopupState";
import ConfirmPopupActions from "./ConfirmPopupActions";
import ConfirmPopupLayout from "./ConfirmPopupLayout";
import ConfirmPopupMessage from "./ConfirmPopupMessage";
import ConfirmPopupTitle from "./ConfirmPopupTitle";
import { ConfirmPopupResult } from "../../../../types/popup";
import { getMessageColor, getTitleColor } from "../../../../utils/popup";
import { useRef } from "react";

/**
 * ConfirmPopup 컴포넌트 구조 설명
 *
 * [ConfirmPopup.tsx]         - 팝업의 로직 및 상태 제어 담당 (Recoil 상태, resolve 처리 등)
 * [ConfirmPopupLayout.tsx]   - 레이아웃 및 외부 모달 래퍼
 * [ConfirmPopupTitle.tsx]    - 제목 영역 UI
 * [ConfirmPopupMessage.tsx]  - 메시지 영역 UI
 * [ConfirmPopupActions.tsx]  - 버튼 영역 UI
 *
 */

const ConfirmPopup = () => {
  const [popup, setPopup] = useRecoilState(confirmPopupState);
  const okButtonRef = useRef(null);

  const titleColor = getTitleColor(popup.variant);
  const messageColor = getMessageColor(popup.variant);

  const handleClose = (result: ConfirmPopupResult) => {
    popup.resolve(result);
    setPopup((prev) => ({ ...prev, isVisible: false }));
  };

  return (
    <ConfirmPopupLayout
      isOpen={popup.isVisible}
      onClose={() => handleClose(ConfirmPopupResult.CANCEL)}
      initialFocusRef={okButtonRef}
    >
      <ConfirmPopupTitle
        color={titleColor}
        onClose={() => handleClose(ConfirmPopupResult.CANCEL)}
      >
        {popup.headerTitle}
      </ConfirmPopupTitle>
      <ConfirmPopupMessage color={messageColor}>{popup.message}</ConfirmPopupMessage>
      <ConfirmPopupActions
        okButtonRef={okButtonRef}
        onCancel={() => handleClose(ConfirmPopupResult.CANCEL)}
        onDontSend={popup.doNotSendButtonTitle ? () => handleClose("dontSend") : undefined}
        onConfirm={() => handleClose(ConfirmPopupResult.OK)}
        cancelLabel={popup.discardButtonTitle}
        dontSendLabel={popup.doNotSendButtonTitle}
        confirmLabel={popup.okButtonTitle}
      />
    </ConfirmPopupLayout>
  );
};

export default ConfirmPopup;
